var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import * as React from 'react';
import React__default, { forwardRef, useRef, useState, useImperativeHandle, useEffect } from 'react';
import { classNames, analyticsTracker } from '@egds/react-core/utils';
import { EGDSButtonSize, EGDSButton, EGDSPrimaryButton, EGDSOverlayButton } from '@egds/react-core/button';
import styles from '../styles/egds-sponsored-content-button-custom-extra-small-with-icon.css';
import { EGDSFigure } from '@egds/react-core/images';
import { EGDSLayoutPosition } from '@egds/react-core/layout-position';
import { useLocalization } from '@shared-ui/localization-context';
import { EGDSIcon, EGDSIconSize } from '@egds/react-core/icons';
import { EGDSLayoutFlexItem, EGDSLayoutFlex } from '@egds/react-core/layout-flex';
import { EGDSLoader } from '@egds/react-core/loader';
import { EGDSScrim, EGDSScrimType } from '@egds/react-core/scrim';
import styles$1 from '../styles/egds-sponsored-content-video-custom.css';
var getClassNameList$2 = classNames.bind(styles);
var ButtonCustomExtraSmallWithIcon = /** @class */function (_super) {
  __extends(ButtonCustomExtraSmallWithIcon, _super);
  function ButtonCustomExtraSmallWithIcon() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ButtonCustomExtraSmallWithIcon.prototype.render = function () {
    var props = this.props;
    var cssClassNames = classNames(getClassNameList$2(props.size === EGDSButtonSize.LARGE ? 'button-custom-large-with-icon' : 'button-custom-extra-small-with-icon', props.className));
    return React.createElement(EGDSButton, __assign(__assign({}, props), {
      className: cssClassNames
    }));
  };
  ButtonCustomExtraSmallWithIcon.displayName = 'ButtonCustomExtraSmallWithIcon';
  ButtonCustomExtraSmallWithIcon.defaultProps = {
    size: EGDSButtonSize.SMALL
  };
  return ButtonCustomExtraSmallWithIcon;
}(React.Component);
var getClassNameList$1 = classNames.bind(styles$1);
var LoadingSpinner = function () {
  return React__default.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: {
      top: 'center',
      left: 'center',
      zindex: 'layer3'
    }
  }, React__default.createElement(EGDSLoader, {
    isDarkBackground: true
  }));
};
var Footer = function (_a) {
  var l10n = _a.l10n,
    callToActionProps = _a.callToActionProps,
    controlBarProps = _a.controlBarProps,
    captionsSrc = _a.captionsSrc,
    isVideoPaused = _a.isVideoPaused,
    isMuted = _a.isMuted,
    isCaptionsOn = _a.isCaptionsOn,
    isFullscreen = _a.isFullscreen,
    handleControlClick = _a.handleControlClick,
    handleMuteClick = _a.handleMuteClick,
    handleClosedCaptionsClick = _a.handleClosedCaptionsClick,
    handleFullscreenClick = _a.handleFullscreenClick;
  var _b = controlBarProps || {},
    _c = _b.useScrim,
    useScrim = _c === void 0 ? true : _c,
    _d = _b.useDefaultCTAButton,
    useDefaultCTAButton = _d === void 0 ? true : _d,
    _e = _b.hasPlayButton,
    hasPlayButton = _e === void 0 ? true : _e,
    _f = _b.hasMuteButton,
    hasMuteButton = _f === void 0 ? true : _f,
    _g = _b.hasClosedCaptionsButton,
    hasClosedCaptionsButton = _g === void 0 ? true : _g,
    _h = _b.hasFullscreenButton,
    hasFullscreenButton = _h === void 0 ? true : _h;
  var _j = callToActionProps || {},
    ctaText = _j.ctaText,
    ctaLink = _j.ctaLink,
    _k = _j.openLinkInNewTab,
    openLinkInNewTab = _k === void 0 ? false : _k;
  var callToActionButton = useDefaultCTAButton && callToActionProps && React__default.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: {
      zindex: 'layer3',
      bottom: 'three',
      left: 'center'
    }
  }, useScrim ? React__default.createElement(EGDSPrimaryButton, {
    size: EGDSButtonSize.MEDIUM,
    "aria-label": ctaText,
    tag: "a",
    href: ctaLink,
    target: openLinkInNewTab ? '_blank' : '_self'
  }, ctaText) : React__default.createElement(EGDSOverlayButton, {
    size: EGDSButtonSize.LARGE,
    "aria-label": ctaText,
    tag: "a",
    href: ctaLink,
    target: openLinkInNewTab ? '_blank' : '_self'
  }, ctaText));
  var buttonClassname = getClassNameList$1('sponsored-content-video-button');
  var playButtonAriaLabel = isVideoPaused ? l10n.formatText('video.playButton.label') : l10n.formatText('video.pauseButton.label');
  var playButton = hasPlayButton && React__default.createElement(EGDSLayoutFlexItem, null, useScrim ? React__default.createElement("button", {
    id: "control-button",
    type: "button",
    "aria-label": playButtonAriaLabel,
    onClick: handleControlClick,
    className: buttonClassname
  }, React__default.createElement(EGDSIcon, {
    name: isVideoPaused ? 'play_arrow' : 'pause',
    theme: "inverse",
    size: EGDSIconSize.MEDIUM
  })) : React__default.createElement(EGDSOverlayButton, {
    size: EGDSButtonSize.LARGE,
    id: "control-button",
    "aria-label": playButtonAriaLabel,
    role: "button",
    onClick: handleControlClick
  }, React__default.createElement(EGDSIcon, {
    name: isVideoPaused ? 'play_arrow' : 'pause',
    size: EGDSIconSize.LARGE
  })));
  var muteButtonAriaLabel = isMuted ? l10n.formatText('videoCustom.volume.unmute.label') : l10n.formatText('videoCustom.volume.mute.label');
  var muteButton = hasMuteButton && React__default.createElement(EGDSLayoutFlexItem, null, useScrim ? React__default.createElement("button", {
    id: "mute-button",
    type: "button",
    "aria-label": muteButtonAriaLabel,
    onClick: handleMuteClick,
    className: buttonClassname
  }, React__default.createElement(EGDSIcon, {
    name: isMuted ? 'volume_off' : 'volume_up',
    theme: "inverse",
    size: EGDSIconSize.MEDIUM
  })) : React__default.createElement(EGDSOverlayButton, {
    id: "mute-button",
    size: EGDSButtonSize.LARGE,
    "aria-label": muteButtonAriaLabel,
    role: "button",
    onClick: handleMuteClick
  }, React__default.createElement(EGDSIcon, {
    name: isMuted ? 'volume_off' : 'volume_up'
  })));
  var closedCaptionAriaLabel = captionsSrc ? isCaptionsOn ? l10n.formatText('videoCustom.closedCaptions.off.label') : l10n.formatText('videoCustom.closedCaptions.on.label') : l10n.formatText('videoCustom.closedCaptions.notAvailable.label');
  var closedCaptionsButtonIcon = captionsSrc ? isCaptionsOn ? 'closed_caption' : 'closed_caption_off' : 'closed_caption_disabled';
  var closedCaptionButton = hasClosedCaptionsButton && React__default.createElement(EGDSLayoutFlexItem, null, useScrim ? React__default.createElement("button", {
    id: "closed-caption-button",
    type: "button",
    "aria-label": closedCaptionAriaLabel,
    onClick: handleClosedCaptionsClick,
    className: buttonClassname,
    disabled: !captionsSrc
  }, React__default.createElement(EGDSIcon, {
    name: closedCaptionsButtonIcon,
    theme: "inverse",
    size: EGDSIconSize.MEDIUM
  })) : React__default.createElement(EGDSOverlayButton, {
    id: "closed-caption-button",
    size: EGDSButtonSize.LARGE,
    "aria-label": closedCaptionAriaLabel,
    role: "button",
    onClick: handleClosedCaptionsClick,
    disabled: !captionsSrc
  }, React__default.createElement(EGDSIcon, {
    name: closedCaptionsButtonIcon
  })));
  var fullscreenButtonAriaLabel = isFullscreen ? l10n.formatText('videoCustom.fullscreen.off.label') : l10n.formatText('videoCustom.fullscreen.on.label');
  var fullscreenButton = hasFullscreenButton && React__default.createElement(EGDSLayoutFlexItem, null, useScrim ? React__default.createElement("button", {
    id: "fullscreen-button",
    type: "button",
    "aria-label": fullscreenButtonAriaLabel,
    onClick: handleFullscreenClick,
    className: buttonClassname
  }, React__default.createElement(EGDSIcon, {
    name: isFullscreen ? 'collapse' : 'expand',
    theme: "inverse",
    size: EGDSIconSize.MEDIUM
  })) : React__default.createElement(EGDSOverlayButton, {
    id: "fullscreen-button",
    size: EGDSButtonSize.LARGE,
    "aria-label": fullscreenButtonAriaLabel,
    role: "button",
    onClick: handleFullscreenClick
  }, React__default.createElement(EGDSIcon, {
    name: isFullscreen ? 'collapse' : 'expand'
  })));
  return React__default.createElement(React__default.Fragment, null, callToActionButton, useScrim ? React__default.createElement(EGDSScrim, {
    type: EGDSScrimType.BOTTOM
  }, React__default.createElement(EGDSLayoutFlex, {
    direction: "row-reverse",
    space: "three"
  }, fullscreenButton, closedCaptionButton, muteButton, playButton)) : React__default.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: {
      zindex: 'layer3',
      bottom: 'three',
      right: 'three'
    }
  }, React__default.createElement(EGDSLayoutFlex, {
    direction: "row",
    space: "three"
  }, playButton, muteButton, closedCaptionButton, fullscreenButton)));
};
var VideoCustomAspectRatio;
(function (VideoCustomAspectRatio) {
  VideoCustomAspectRatio["R4_3"] = "ratio-4-3";
  VideoCustomAspectRatio["R16_9"] = "ratio-16-9";
  VideoCustomAspectRatio["R21_9"] = "ratio-21-9";
  VideoCustomAspectRatio["R3_4"] = "ratio-3-4";
  VideoCustomAspectRatio["R9_16"] = "ratio-9-16";
})(VideoCustomAspectRatio || (VideoCustomAspectRatio = {}));
var VideoCustomClickAction;
(function (VideoCustomClickAction) {
  VideoCustomClickAction["PLAY_PAUSE"] = "play-pause";
  VideoCustomClickAction["CALL_TO_ACTION"] = "call-to-action";
  VideoCustomClickAction["NONE"] = "none";
})(VideoCustomClickAction || (VideoCustomClickAction = {}));
var getClassNameList = classNames.bind(styles$1);
var VideoCustom = forwardRef(function (props, ref) {
  var l10n = useLocalization();
  var _a = props.videoResource,
    src = _a.src,
    thumbnail = _a.thumbnail,
    captionsSrc = _a.captionsSrc,
    adBadge = props.adBadge,
    analytics = props.analytics,
    _b = props.autoplay,
    autoplay = _b === void 0 ? true : _b,
    _c = props.preloadAuto,
    preloadAuto = _c === void 0 ? true : _c,
    callToActionProps = props.callToActionProps,
    footerContent = props.footerContent,
    midSection = props.midSection,
    _d = props.isMobile,
    isMobile = _d === void 0 ? false : _d,
    onComplete = props.onComplete,
    onError = props.onError,
    _e = props.preserveAspectRatio,
    preserveAspectRatio = _e === void 0 ? false : _e,
    _f = props.ratio,
    ratio = _f === void 0 ? VideoCustomAspectRatio.R16_9 : _f,
    topSection = props.topSection,
    _g = props.videoAriaLabel,
    videoAriaLabel = _g === void 0 ? l10n.formatText('videoCustom.video.label') : _g,
    _h = props.videoClickAction,
    videoClickAction = _h === void 0 ? VideoCustomClickAction.PLAY_PAUSE : _h,
    _j = props.visibleAutoplayThreshold,
    visibleAutoplayThreshold = _j === void 0 ? 0.5 : _j,
    _k = props.isVideoMuted,
    isVideoMuted = _k === void 0 ? true : _k,
    _l = props.videoId,
    videoId = _l === void 0 ? "video-player" : _l;
  var _m = footerContent || {},
    customFooter = _m.customFooter,
    controlBarProps = _m.controlBarProps;
  var _o = (controlBarProps || {}).controlButtonsInactivityTimeout,
    controlButtonsInactivityTimeout = _o === void 0 ? 3 : _o;
  var _p = callToActionProps || {},
    ctaLink = _p.ctaLink,
    _q = _p.openLinkInNewTab,
    openLinkInNewTab = _q === void 0 ? false : _q,
    ctaClickAnalytics = _p.ctaClickAnalytics;
  // Standard for video ads is to count as a view after 2 seconds.
  var viewDurationTrackingThreshold = 2;
  var videoAnalytics = analytics || {};
  var viewAnalytics = videoAnalytics.viewAnalytics,
    firstQuartileAnalytics = videoAnalytics.firstQuartileAnalytics,
    midpointAnalytics = videoAnalytics.midpointAnalytics,
    thirdQuartileAnalytics = videoAnalytics.thirdQuartileAnalytics,
    completeAnalytics = videoAnalytics.completeAnalytics,
    playAnalytics = videoAnalytics.playAnalytics,
    pauseAnalytics = videoAnalytics.pauseAnalytics,
    muteAnalytics = videoAnalytics.muteAnalytics,
    unmuteAnalytics = videoAnalytics.unmuteAnalytics,
    bufferingAnalytics = videoAnalytics.bufferingAnalytics;
  var videoElement = useRef(null);
  var _r = __read(useState(!autoplay), 2),
    isVideoPaused = _r[0],
    setIsVideoPaused = _r[1];
  var _s = __read(useState(isVideoMuted), 2),
    isMuted = _s[0],
    setIsMuted = _s[1];
  var _t = __read(useState(false), 2),
    isFullscreen = _t[0],
    setIsFullscreen = _t[1];
  var _u = __read(useState(false), 2),
    isCaptionsOn = _u[0],
    setIsCaptionsOn = _u[1];
  var _v = __read(useState(false), 2),
    isVisible = _v[0],
    setIsVisible = _v[1];
  var _w = __read(useState(false), 2),
    isHovering = _w[0],
    setIsHovering = _w[1];
  var _x = __read(useState(autoplay), 2),
    isBuffering = _x[0],
    setIsBuffering = _x[1];
  var _y = __read(useState(false), 2),
    isLooping = _y[0],
    setIsLooping = _y[1];
  var handleMuteClick = function () {
    if (videoElement.current instanceof HTMLVideoElement) {
      if (videoElement.current.muted) {
        unmuteAnalytics && analyticsTracker(unmuteAnalytics);
      } else {
        muteAnalytics && analyticsTracker(muteAnalytics);
      }
      videoElement.current.muted = !videoElement.current.muted;
      setIsMuted(!isMuted);
    }
  };
  var handleControlClick = function () {
    if (videoElement.current instanceof HTMLVideoElement) {
      if (videoElement.current.paused) {
        setIsVideoPaused(false);
        playAnalytics && analyticsTracker(playAnalytics);
      } else {
        setIsVideoPaused(true);
        pauseAnalytics && analyticsTracker(pauseAnalytics);
      }
    }
  };
  // To be called when an overlay component needs to be shown on top of the video
  // Pause if it's currently playing
  var showOverlay = function () {
    if (videoElement.current instanceof HTMLVideoElement && !isVideoPaused) {
      videoElement.current.pause();
    }
  };
  // To be called when an overlay component is dismissed
  // Resume if it was playing before
  var dismissOverlay = function () {
    if (videoElement.current instanceof HTMLVideoElement && !isVideoPaused) {
      videoElement.current.play();
    }
  };
  // To be called to toggle Play and Pause
  var togglePlayPause = function () {
    if (videoElement.current instanceof HTMLVideoElement) {
      var isPaused = videoElement.current.paused;
      if (isPaused) {
        videoElement.current.play();
      } else {
        videoElement.current.pause();
      }
      setIsVideoPaused(!isPaused);
    }
  };
  // To be called to toggle Mute and Unmute
  var toggleMuteUnmute = function () {
    if (videoElement.current instanceof HTMLVideoElement) {
      videoElement.current.muted = !videoElement.current.muted;
      setIsMuted(videoElement.current.muted);
    }
  };
  useImperativeHandle(ref, function () {
    return {
      showOverlay: showOverlay,
      dismissOverlay: dismissOverlay,
      togglePlayPause: togglePlayPause,
      toggleMuteUnmute: toggleMuteUnmute
    };
  });
  var handleClosedCaptionsClick = function () {
    if (videoElement.current instanceof HTMLVideoElement) {
      var ccTrack = Array.from(videoElement.current.textTracks).find(function (track) {
        return track.kind === 'captions';
      });
      if (ccTrack) {
        if (isCaptionsOn) {
          ccTrack.mode = 'disabled';
        } else {
          ccTrack.mode = 'showing';
        }
        setIsCaptionsOn(!isCaptionsOn);
      }
    }
  };
  var handleFullscreenClick = function () {
    var _a;
    var videoContainer = (_a = videoElement.current) === null || _a === void 0 ? void 0 : _a.parentElement;
    if (isFullscreen) {
      document.exitFullscreen();
    } else if (videoContainer instanceof HTMLElement) {
      videoContainer.requestFullscreen();
    }
    setIsFullscreen(!isFullscreen);
  };
  var handleVideoComplete = function () {
    if (videoElement.current instanceof HTMLVideoElement) {
      completeAnalytics && analyticsTracker(completeAnalytics);
      onComplete && onComplete();
      setIsLooping(true);
      setIsBuffering(false);
      videoElement.current.play();
    }
  };
  var handleLoadError = function (event) {
    onError && onError(event);
  };
  var _z = __read(useState(true), 2),
    isTabVisible = _z[0],
    setIsTabVisible = _z[1];
  var handleVisibilityChange = function () {
    setIsTabVisible(document.visibilityState === 'visible');
  };
  var isMounted = useRef(false);
  useEffect(function () {
    isMounted.current = true;
    var observer = new IntersectionObserver(function (_a) {
      var _b = __read(_a, 1),
        entry = _b[0];
      if (entry && isMounted.current) {
        setIsVisible(entry.isIntersecting);
      }
    }, {
      threshold: visibleAutoplayThreshold
    });
    if (videoElement.current) {
      observer.observe(videoElement.current);
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return function () {
      isMounted.current = false;
      observer.disconnect();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  // Show controls ref set to true at first so reappearance tracking event is not sent the first time the controls appear on video play button clicked.
  var showControlsRef = useRef(true);
  var _0 = __read(useState(true), 2),
    recentlyResumed = _0[0],
    setRecentlyResumed = _0[1];
  var _1 = __read(useState(false), 2),
    showControls = _1[0],
    setShowControls = _1[1];
  var controlsTimeoutId;
  var showControlsHandler = function (show) {
    setShowControls(show);
    showControlsRef.current = show;
  };
  var handleControlsTimeout = function () {
    var _a;
    if (showControlsRef.current && !((_a = videoElement.current) === null || _a === void 0 ? void 0 : _a.paused)) {
      showControlsHandler(false);
    }
    setRecentlyResumed(false);
  };
  var resetInactivityTimer = function () {
    clearTimeout(controlsTimeoutId);
    controlsTimeoutId = setTimeout(handleControlsTimeout, controlButtonsInactivityTimeout * 1000);
  };
  var handleMouseMove = function () {
    if (!showControlsRef.current) {
      showControlsHandler(true);
    }
    resetInactivityTimer();
  };
  useEffect(function () {
    if (videoElement.current instanceof HTMLVideoElement && !isVideoPaused) {
      if (!isMobile) {
        videoElement.current.addEventListener('mousemove', handleMouseMove);
      }
      setRecentlyResumed(true);
      resetInactivityTimer();
    }
    return function () {
      var _a;
      clearTimeout(controlsTimeoutId);
      if (!isMobile) {
        (_a = videoElement.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('mousemove', handleMouseMove);
      }
    };
  }, [isVideoPaused]);
  useEffect(function () {
    // Only override showControls if video not recently resumed - desktop only
    if (!isVideoPaused && !recentlyResumed && !isMobile) {
      showControlsHandler(isHovering);
      if (isHovering) {
        resetInactivityTimer();
      }
    }
    return function () {
      clearTimeout(controlsTimeoutId);
    };
  }, [isHovering, recentlyResumed]);
  useEffect(function () {
    if (videoElement.current instanceof HTMLVideoElement && isVisible && isTabVisible) {
      if (isVideoPaused) {
        videoElement.current.pause();
      } else {
        videoElement.current.play();
        setIsVideoPaused(false);
      }
      videoElement.current.muted = isMuted;
      showControlsHandler(true);
      resetInactivityTimer();
    } else if (videoElement.current instanceof HTMLVideoElement) {
      videoElement.current.pause();
    }
  }, [isVisible, isTabVisible, isVideoPaused, isMuted, visibleAutoplayThreshold]);
  var _2 = __read(useState({
      view: false,
      firstQuartile: false,
      midpoint: false,
      thirdQuartile: false,
      viewedPreview: false
    }), 2),
    videoProgressTrackers = _2[0],
    setVideoProgressTrackers = _2[1];
  var handleTimeProgress = function () {
    if (videoElement.current instanceof HTMLVideoElement && videoElement.current.duration !== 0) {
      var currentTime = videoElement.current.currentTime;
      var duration = videoElement.current.duration;
      var viewed = currentTime >= viewDurationTrackingThreshold;
      var firstQuartileComplete = currentTime / duration >= 0.25;
      var midpointComplete = currentTime / duration >= 0.5;
      var thirdQuartileComplete = currentTime / duration >= 0.75;
      if (viewed && !videoProgressTrackers.view) {
        viewAnalytics && analyticsTracker(viewAnalytics);
        setVideoProgressTrackers(__assign(__assign({}, videoProgressTrackers), {
          view: true
        }));
      }
      if (firstQuartileComplete && !videoProgressTrackers.firstQuartile) {
        firstQuartileAnalytics && analyticsTracker(firstQuartileAnalytics);
        setVideoProgressTrackers(__assign(__assign({}, videoProgressTrackers), {
          firstQuartile: true
        }));
      }
      if (midpointComplete && !videoProgressTrackers.midpoint) {
        midpointAnalytics && analyticsTracker(midpointAnalytics);
        setVideoProgressTrackers(__assign(__assign({}, videoProgressTrackers), {
          midpoint: true
        }));
      }
      if (thirdQuartileComplete && !videoProgressTrackers.thirdQuartile) {
        thirdQuartileAnalytics && analyticsTracker(thirdQuartileAnalytics);
        setVideoProgressTrackers(__assign(__assign({}, videoProgressTrackers), {
          thirdQuartile: true
        }));
      }
    }
  };
  var handleVideoClick = function () {
    if (isMobile && !showControls) {
      // First tap on a mobile device when the controls are hidden will unhide the controls
      handleMouseMove();
    } else {
      switch (videoClickAction) {
        case VideoCustomClickAction.CALL_TO_ACTION:
          ctaClickAnalytics && analyticsTracker(ctaClickAnalytics);
          window.open(ctaLink, openLinkInNewTab ? '_blank' : '_self');
          break;
        case VideoCustomClickAction.NONE:
          break;
        // Play/pause is the default action
        case VideoCustomClickAction.PLAY_PAUSE:
        default:
          handleControlClick();
          break;
      }
    }
  };
  var handleVideoBuffering = function () {
    if (!isLooping) {
      bufferingAnalytics && analyticsTracker(bufferingAnalytics);
      setIsBuffering(true);
      if (props === null || props === void 0 ? void 0 : props.onVideoLoading) {
        props.onVideoLoading(true);
      }
    }
  };
  var handleVideoPlaying = function () {
    setIsBuffering(false);
    setIsLooping(false);
    if (props === null || props === void 0 ? void 0 : props.onVideoLoading) {
      props.onVideoLoading(false);
    }
  };
  var videoComponent = React__default.createElement("video", {
    "aria-label": videoAriaLabel,
    controlsList: "nodownload noplaybackrate",
    disablePictureInPicture: true,
    id: videoId,
    muted: true,
    onEnded: handleVideoComplete,
    onError: handleLoadError,
    onTimeUpdate: handleTimeProgress,
    onClick: handleVideoClick,
    onWaiting: handleVideoBuffering,
    onPlaying: handleVideoPlaying,
    playsInline: true,
    poster: thumbnail,
    preload: preloadAuto ? 'auto' : 'metadata',
    ref: videoElement,
    className: getClassNameList('sponsored-content-video', {
      'sponsored-content-video-preserve-aspect-ratio': preserveAspectRatio
    })
  }, React__default.createElement("source", {
    src: src
  }), captionsSrc && React__default.createElement("track", {
    src: captionsSrc,
    kind: "captions",
    srcLang: "en",
    label: "English"
  }));
  return React__default.createElement("div", {
    onMouseEnter: function () {
      return setIsHovering(true);
    },
    onMouseLeave: function () {
      return setIsHovering(false);
    }
  }, React__default.createElement(EGDSFigure, {
    className: getClassNameList("sponsored-content-video-".concat(ratio))
  }, videoComponent, isBuffering && React__default.createElement(LoadingSpinner, null), showControls && (customFooter ? React__default.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: {
      zindex: 'layer3',
      bottom: 'three',
      left: 'center'
    }
  }, customFooter) : React__default.createElement(Footer, {
    l10n: l10n,
    controlBarProps: controlBarProps,
    captionsSrc: captionsSrc,
    isVideoPaused: isVideoPaused,
    isMuted: isMuted,
    isCaptionsOn: isCaptionsOn,
    isFullscreen: isFullscreen,
    handleControlClick: handleControlClick,
    handleMuteClick: handleMuteClick,
    handleClosedCaptionsClick: handleClosedCaptionsClick,
    handleFullscreenClick: handleFullscreenClick
  })), topSection && (showControls || !topSection.disappearsWithControls) && React__default.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: {
      zindex: 'layer3',
      top: 'three',
      left: 'center'
    }
  }, topSection.sectionComponent), midSection && (showControls || !midSection.disappearsWithControls) && React__default.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: {
      zindex: 'layer3',
      top: 'center',
      left: 'center'
    }
  }, midSection.sectionComponent), React__default.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: {
      zindex: 'layer3',
      bottom: 'three',
      left: 'three'
    }
  }, adBadge)));
});
VideoCustom.displayName = 'VideoCustom';
export { ButtonCustomExtraSmallWithIcon, VideoCustom, VideoCustomAspectRatio, VideoCustomClickAction };